import Plyr from 'plyr';

window.initNewsDetailsPage = () => {
    var thumbsSwiper = new Swiper('.news-media--thumbs', {
        // loop: true,
        spaceBetween: 10,
        slidesPerView: 2,
        freeMode: false,
        watchSlidesProgress: true,
        breakpoints: {
            1300: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 3,
            },
        },
    });
    new Swiper('.news-media--slider', {
        // loop: true,
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-navigation-buttons--next",
            prevEl: ".swiper-navigation-buttons--prev",
        },
        thumbs: {
            swiper: thumbsSwiper,
        },
        preloadImages: false,
        lazy: {
            loadPrevNext: true,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"><span class="dot-1"><span class="dot-2"></span></span></span>';
            },
        },
        noSwipingClass: 'plyr__controls',
        breakpoints: {
            1024: {
                pagination: false,
            },
        }
    });

    if ($('#player').length) {
        const player = new Plyr('#player');
        player.on('ready', event => {
            const instance = event.detail.plyr;

            $('.youtube-thumb').attr('src', instance.poster);
        });

        window.player = player;
    }
}
